import React, { Component } from 'react';
import { connect } from 'react-redux';

import { changePageCount } from '../../actions';

class LimitCount extends Component {
	constructor( props ) {
		super( props );
		this.handleChange = this.handleChange.bind( this );
	}

	handleChange( event ) {
		this.props.changePageCount( event.target.dataset.count );
	}

	renderLimitCountOptions() {
		const options = [12, 36, 64];
		return options.map( option => {
			return (<li key={ option }>
					<button type="button"
					        name={ 'display-' + option }
					        data-count={ option }
					        onClick={ this.handleChange }>Display { option }</button>
				</li>
			);
		} );
	}

	getOpinionStats() {
		if ( this.props.opinionStats.totalPublished > 0 ) {
			return (<p>Commissioned
					Opinions: { this.props.opinionStats.commissioned }<br/>
					Total Published
					Opinions: { this.props.opinionStats.totalPublished }
				</p>
			);
		} else {
			return (<p></p>
			);
		}
	}

	render() {
		let count = (parseInt( this.props.pagination.perPage ) < parseInt( this.props.pagination.totalResults )
		            )
		            ? this.props.pagination.perPage
		            : this.props.pagination.totalResults;
		return (<div className="info-container" id="opinions-sorting-bar">
				<div>
					<span>
						Found { this.props.pagination.totalResults } opinions
					</span>
					<div className="opinions-commissioned-total">
						{ this.getOpinionStats() }
					</div>
					<ul className="dropdown-menu" aria-labelledby="">
						{ this.renderLimitCountOptions() }
					</ul>
				</div>
				<div>
					<a href="/opinions-library/?action=get_opinions_report"
					   className="btn btn-primary btn-opi-lib-btns">
						Download Report
					</a>
					<a href="/rss-subscription/"
					   className="btn btn-primary btn-opi-lib-btns">
						My ISDA Legal Opinions Notifications
					</a>
				</div>
			</div>
		);
	}
}

function mapStateToProps( { pagination, opinionStats } ) {
	return { pagination, opinionStats };
}

export default connect( mapStateToProps, {
	changePageCount
} )( LimitCount );